import { Rsvp } from '../models/rsvp';

export class ComparatorUtils {
  static isDefined(obj: any): boolean {
    if (obj === null || typeof obj === 'undefined') {
      return false;
    } else {
      return true;
    }
  }

  static isUndefined(obj: any): boolean {
    return !ComparatorUtils.isDefined(obj);
  }

  static compareNullable(obj1: any, obj2: any): number {
    if (ComparatorUtils.isUndefined(obj1) && ComparatorUtils.isUndefined(obj2)) {
      return 0;
    } else if (ComparatorUtils.isDefined(obj1) && ComparatorUtils.isUndefined(obj2)) {
      return -1;
    } else if (ComparatorUtils.isUndefined(obj1) && ComparatorUtils.isDefined(obj2)) {
      return 1;
    } else {
      return 0;
    }
  }

  static compareString(string1: string, string2: string): number {
    const nullCompare = ComparatorUtils.compareNullable(string1, string2);
    if (nullCompare !== 0) {
      return nullCompare;
    } else if (string1.toLowerCase() < string2.toLowerCase()) {
      return -1;
    } else if (string1.toLowerCase() > string2.toLowerCase()) {
      return 1;
    } else {
      return 0;
    }
  }

  static compareLastNameFirstName(fullName1: { firstName, lastName }, fullName2: { firstName, lastName }): number {
    const nullCompare = ComparatorUtils.compareNullable(fullName1, fullName2);
    if (nullCompare !== 0) {
      return nullCompare;
    }
    const firstNameNullCompare = ComparatorUtils.compareNullable(fullName1.firstName, fullName2.firstName);
    if (firstNameNullCompare !== 0) {
      return firstNameNullCompare;
    }
    const lastNameNullCompare = ComparatorUtils.compareNullable(fullName1.lastName, fullName2.lastName);
    if (lastNameNullCompare !== 0) {
      return lastNameNullCompare;
    }
    if (ComparatorUtils.isDefined(fullName1.lastName) && ComparatorUtils.isDefined(fullName2.lastName)) {
      const lastNameCompare = ComparatorUtils.compareString( fullName1.lastName, fullName2.lastName );
      if ( lastNameCompare !== 0 ) {
        return lastNameCompare;
      }
    }
    if (ComparatorUtils.isDefined(fullName1.firstName) && ComparatorUtils.isDefined(fullName2.firstName)) {
      const firstNameCompare = ComparatorUtils.compareString( fullName1.firstName, fullName2.firstName );
      if ( firstNameCompare !== 0 ) {
        return firstNameCompare;
      }
    }
    return 0;
  }

  static compareRsvps(rsvp1: Rsvp, rsvp2: Rsvp): number {
    return ComparatorUtils.compareLastNameFirstName(
      { firstName: rsvp1.firstName, lastName: rsvp1.lastName },
      { firstName: rsvp2.firstName, lastName: rsvp2.lastName });
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/utils/comparator-utils.ts